import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

/**
 * Small "?" next to a page title that deep-links into the help center:
 *   <HelpLink slug="payments" />  ->  /help?article=payments
 */
const HelpLink = ({ slug, className = '' }) => (
  <Link
    to={`/help?article=${slug}`}
    title="Open help for this page"
    aria-label="Open help for this page"
    className={`inline-flex items-center text-slate-300 hover:text-blue-600 transition-colors align-middle ${className}`}
  >
    <HelpCircle className="h-4 w-4" />
  </Link>
);

export default HelpLink;
